import type { PromptResolve } from '@ur-solutions/react-components'
import { useForm, useTranslate } from '@ur-solutions/react-hooks'
import { Input, RegularModal } from '@/components_deprecated'
import type {
  VehicleExpirationTypeForm} from '@/modules/companies/CompanySettings';
import {
  Field,
  Form,
} from '@/modules/companies/CompanySettings'
import React from 'react'

interface AddVehicleExpirationTypeModalProps {
  onSubmit: PromptResolve<VehicleExpirationTypeForm | null>
}

export const AddVehicleExpirationTypeModal: React.FC<
  AddVehicleExpirationTypeModalProps
> = ({ onSubmit }) => {
  const translations = useTranslate({
    modalTitle: 'settings.add-vehicle-expiration-type',
    add: 'common.add',
    name: 'common.name',
  })

  const {
    formValues,
    formEdited,
    formErrors,
    formChangeHandler,
    submitHandler: submit,
  } = useForm<VehicleExpirationTypeForm>({
    values: {
      categoryName: '',
    },
  })

  return (
    <RegularModal
      title={translations.modalTitle}
      submitText={translations.add}
      submitDisabled={!formEdited}
      cancelOnClickOutside
      width="450px"
      onSubmit={submit(onSubmit)}
      onCancel={() => onSubmit(null)}
    >
      <Form>
        <Field>
          <label>{translations.name}</label>
          <Input
            value={formValues.categoryName}
            error={formErrors.categoryName}
            autoFocus
            fullWidth
            onChange={formChangeHandler('categoryName')}
          />
        </Field>
      </Form>
    </RegularModal>
  )
}
